// File used to manage the callbacks passed from the mapcontrolscomponent
import { MapControlsContextValue } from 'constants/index';
import React from 'react';

export const MapControlsContext = React.createContext<MapControlsContextValue>({
  onAddZone: undefined,
  onSave: undefined
});
